/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IGetDailyCrewWorkOverviewRequest } from '../models/daily-crew-work-overview.model';
import { IWorkOverviewMatrixRequest } from '../models/work-overview-matrix.model';

export class LoadWorkOverviewList {
  static readonly type = '[WorkOverviews] Load Work Overview List via Service';
  constructor(
    public date: IWorkOverviewMatrixRequest,
    public filter?: MainTableFilterModel
  ) {}
}

export class LoadWorkOverviewDetailsById {
  static readonly type = '[WorkOverviews] Load Work Overview Details By Id via Service';
  constructor(
    public id: string,
    public year: number,
    public month: number,
    public showFuture: boolean | null,
    public showWorkPlan: boolean | null
  ) {}
}

export class LoadAlternativeWorkOverviewById {
  static readonly type = '[WorkOverviews] Load Alternative Work Overview By Id via Service';
  constructor(
    public id: string,
    public year: number,
    public month: number
  ) {}
}

export class PrintWorkOverviewById {
  static readonly type = '[WorkOverviews] Print Work Overview By Id via Service';
  constructor(
    public id: string,
    public year: number,
    public month: number
  ) {}
}

export class PrintWorkOverviews {
  static readonly type = '[WorkOverviews] Print Work Overviews via Service';
  constructor(
    public year: number,
    public month: number
  ) {}
}

export class LoadAvailablePersonnel {
  static readonly type = '[WorkOverview] Load Available Personnel';
  constructor(
    public hasAssignedWorkSchedule?: boolean | null,
    public isForWorkPlan?: boolean | null,
    public from?: string,
    public to?: string | null,
    public isForWorkScheduleAssignment?: boolean | null
  ) {}
}

export class ClearCurrentWorkOverview {
  static readonly type = '[WorkOverviews] Clear current work overview';
}

export class LoadDailyCrewWorkOverview {
  static readonly type = '[WorkOverviews] Load Daily Crew Work Overview via Service';
  constructor(public request: IGetDailyCrewWorkOverviewRequest) {}
}

export class ClearDailyCrewWorkOverview {
  static readonly type = '[WorkOverviews] Clear daily crew work overview';
}
